// extracted by mini-css-extract-plugin
export default {"peer-reviewed-field":"peer-reviewed-field---BK9YU"};